import SearchAreaModel from './SearchAreaModel'

export default class VehicleType {
    id !: string
    label !: string
    name !: string
    icon !: string
    searchAreas : Array<any> = []
    status!: string

    set (input: any): VehicleType {
      this.id = input.id
      this.name = input.name
      // If icon name starts with fa remove it
      if (input.iconName.lastIndexOf('fa-', 0) === 0) {
        input.iconName = input.iconName.slice(3)
      }
      this.icon = input.iconName

      let areas = []


      for (let index = 0; index < input.searchAreas.length; index++) {
        let area = new SearchAreaModel().set(input.searchAreas[index])
        areas.push(area)
      }

      this.searchAreas = areas

      return this
    }

    convertFromObject (input: any): VehicleType {
      this.id = input.id
      this.name = input.name
      this.icon = input.icon

      this.searchAreas = input.searchAreas

      return this
    }

    shuffleAreas (): Array<SearchAreaModel> {
      let currentIndex = this.searchAreas.length
      let temporaryValue, randomIndex
      let tempArray = []

      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1

        // And swap it with the current element.
        temporaryValue = this.searchAreas[currentIndex]
        this.searchAreas[currentIndex] = this.searchAreas[randomIndex]
        this.searchAreas[randomIndex] = temporaryValue
      }

      tempArray = this.searchAreas.slice(0, 3)
      this.searchAreas = []

      tempArray.forEach(area => {
        this.searchAreas.push(Object.assign(new SearchAreaModel(true), area))
      })

      return this.searchAreas

    }
}
